module.exports = __webpack_public_path__ + "media/images/squadBet__iconChange-86072d2befdb81189f745b7503f72a04.png";